import api from "..";
import { playListPassword, playListUsername } from "../../../state";
import {
  convertItemsToTiles,
  chunkArray,
  convertItemsToTilesChannel,
  convertItemsToTilesSeries,
  convertItemsToTilesMovies,
  chunkArraySeries,
  convertItemsToTilesMoviesSearch,
  convertItemsToTilesLiveSearch,
} from "../formatters/ItemFormatter";
import { dnsResolver } from "./dnsResolver"; // Import your DNS resolver

let cache = new Map();
const leftoverTiles = new Map();

export default function (filter: string, category_id: number) {
  return async (pageIndex: number): Promise<any> => {
    const username = playListUsername();
    const password = playListPassword();

    let originalUrl = `/player_api.php?username=${username}&password=${password}&action=get_live_streams`;
    let finalUrl = originalUrl;
    let hostHeader = null;

    // Check cache first
    if (cache.has(originalUrl)) {
      console.log(`💾 Using cached data for search/live streams`);
      return cache.get(originalUrl);
    }

    // CUSTOM DNS TRANSFORMATION
    try {
      // Get the base URL from your API instance
      const baseUrl = api.baseURL || api.defaults?.baseURL || window.location.origin;
      const fullUrl = `${baseUrl}${originalUrl}`;

      console.log(`🌐 Starting DNS transformation for search/live streams: ${fullUrl}`);
      console.log(`🔧 DNS Info:`, dnsResolver.getDnsInfo());

      // Apply custom DNS if enabled
      const dnsResult = await dnsResolver.transformUrl(fullUrl);

      console.log(`📡 DNS transformation result for search/live streams:`, dnsResult);

      if (typeof dnsResult === "object" && dnsResult.url) {
        // Custom DNS successfully transformed the URL
        finalUrl = dnsResult.url.replace(baseUrl, ""); // Get relative path
        hostHeader = dnsResult.originalHost;
        console.log(`✅ Custom DNS applied to search/live streams:`);
        console.log(`   Original: ${fullUrl}`);
        console.log(`   Transformed: ${dnsResult.url}`);
        console.log(`   Host header: ${hostHeader}`);
      } else if (typeof dnsResult === "string") {
        // URL returned as string (might be unchanged)
        if (dnsResult !== fullUrl) {
          finalUrl = dnsResult.replace(baseUrl, "");
          console.log(`🔄 Search/live streams URL modified: ${dnsResult}`);
        } else {
          console.log(`📝 Search/live streams URL unchanged (localhost or DNS disabled)`);
        }
      }
    } catch (dnsError) {
      console.warn("❌ DNS transformation failed for search/live streams:", dnsError);
      finalUrl = originalUrl; // Use original URL
    }

    console.log(`📞 Making search/live streams API call with URL: ${finalUrl}`);

    // Make the API call
    let result = api
      ._get(finalUrl, {
        // Add Host header if we have one (for custom DNS)
        ...(hostHeader && { headers: { Host: hostHeader } }),
      })
      .then(series => {
        console.log(`✅ Search/live streams API call successful, processing ${series?.length || 0} streams`);

        let results = series;
        let tiles = (leftoverTiles.has(filter) ? leftoverTiles.get(filter) : []).concat(
          convertItemsToTilesLiveSearch(results),
        );

        let chunks = chunkArraySeries(tiles);
        if (chunks[chunks.length - 1].length < 7) {
          leftoverTiles.set(filter, chunks.pop());
        } else {
          leftoverTiles.delete(filter);
        }

        console.log(`🔍 Search/live streams processed: ${tiles.length} total tiles created`);
        return tiles;
      })
      .catch(error => {
        console.error(`❌ Search/live streams API call failed:`, error);
        // Remove from cache if request fails
        cache.delete(originalUrl);
        throw error;
      });

    cache.set(originalUrl, result);
    return result;
  };
}
